import { track } from '@vercel/analytics'

export function trackAIReferral(): void {
  if (typeof window === 'undefined') return

  const referrer = document.referrer
  const userAgent = navigator.userAgent

  const aiPlatforms = [
    { name: 'ChatGPT', pattern: /chatgpt\.com|gptbot|oai-searchbot/i },
    { name: 'Perplexity', pattern: /perplexity\.ai|perplexitybot/i },
    { name: 'Claude', pattern: /claude\.ai|claudebot|anthropic-ai/i },
    { name: 'Gemini', pattern: /gemini\.google\.com|google-extended/i },
    { name: 'Mistral', pattern: /mistral\.ai|mistralai-user/i },
    { name: 'DuckDuckGo AI', pattern: /duckassistbot/i },
    { name: 'Grok', pattern: /grok\.com|grokbot|xai-bot/i },
  ] as const

  const platform = aiPlatforms.find(
    (p) => p.pattern.test(referrer) || p.pattern.test(userAgent)
  )

  if (!platform) return

  try {
    const key = 'ai_ref_platform'
    window.localStorage.setItem(key, platform.name)
  } catch {}

  track('ai_referral', {
    ai_platform: platform.name,
    referrer,
  })
}
